export default {
  Offer: {
    AbodeProPlan: 'AbodeProPlan',
    ConnectedHome: 'ConnectedHome',
    NewConnectedHomeSignUpCustomer: 'NewConnectedHomeSignUpCustomer'
  },
  Policy: {
    CrossSellEligibility: 'CrossSellEligibility',
    SignedConversionDocuments: 'SignedConversionDocuments'
  },
  Customer: {
    CrossSellEligibility: 'CrossSellEligibility'
  }
};
